export default "__VITE_ASSET__c0edae59__"